export const bugValidation = {
  shortDescription: {
    type: 'string',
    required: true,
  },
  isCritical: {
    type: 'string',
    required: true,
  },
  linkToDetails: {
    type: 'string',
    link: true,
  },
  notes: {
    type: 'string',
  },
};
